import { all, takeLatest, put, select, delay } from 'redux-saga/effects';

import { IdleTimeoutTypes } from './idleTimeout.redux';
import { SnackbarActions } from '../snackbar/snackbar.redux';
import { SNACKBAR_TIMEOUT_SNACKBAR } from '../snackbar/snackbar.constants';
import { selectCurrentExperienceId } from '../experience';
import { WARNING_TIMEOUT } from './idleTimeout.constants';
import { selectIsBookingActive, BookingActions } from '../booking';
import history from '../../shared/utils/history';
import { selectCurrentKioskHomeRoute, selectIsKioskMode } from '../kiosk';
import { OverlayActions } from '../overlay';

function* handleIdleChange({ isIdle }) {
  if (!isIdle) {
    yield put(SnackbarActions.hideSnackbar());
    return;
  }

  const isExperienceSelected = yield select(selectCurrentExperienceId);
  const isKioskMode = yield select(selectIsKioskMode);

  if (!isExperienceSelected || !isKioskMode) {
    return;
  }

  yield put(SnackbarActions.showSnackbar(SNACKBAR_TIMEOUT_SNACKBAR, WARNING_TIMEOUT));
  yield delay(WARNING_TIMEOUT);

  yield put(OverlayActions.hideOverlay());

  const isBookingActive = yield select(selectIsBookingActive);
  if (isBookingActive) {
    yield put(BookingActions.closeBooking());
  } else {
    const kioskUrl = yield select(selectCurrentKioskHomeRoute);
    history.push(kioskUrl);
  }
}

export default function* startupSaga() {
  yield all([takeLatest(IdleTimeoutTypes.IDLE_CHANGE, handleIdleChange)]);
}
